import { combineReducers } from 'redux';
import { objectList } from './objectListReducer';
import { releaseDetail } from './releaseDetailReducer';


export default combineReducers({
  objectList,
  releaseDetail,
});
